// extracted by css-extract-rspack-plugin
export default {"SidePanel":"CopilotSidePanelSidebar-module__SidePanel__L3O0C","HiddenSidePanel":"CopilotSidePanelSidebar-module__HiddenSidePanel__TBRGn"};